/* eslint-disable import/prefer-default-export */
const GO_LEARN_MORE = 'learn-more/GO';

export { GO_LEARN_MORE };

/* eslint-enable import/prefer-default-export */



// WEBPACK FOOTER //
// ./src/store/actions/learnMore.types.js